export interface IFeedbackMetadata {
  url: string;
  browser: string;
  screen_resolution: string;
  source: 'web';
}

/**
 * Собрать метаданные окружения для сообщения обратной связи.
 * Вызывается в момент отправки: модалка не роут, поэтому URL к этому
 * моменту совпадает с экраном, на котором пользователь заметил проблему.
 */
export const getFeedbackMetadata = (): IFeedbackMetadata => ({
  browser: navigator.userAgent,
  screen_resolution: `${screen.width}x${screen.height} (viewport ${window.innerWidth}x${window.innerHeight})`,
  // Источник фиксированный: это веб-клиент. Мобильное приложение шлёт 'mobile'
  // и кладёт окружение устройства в browser
  source: 'web',
  url: location.href
});
